angular.module("qbePortal").controller("PaymentController", [
	"$rootScope",
	"$scope",
	"$state",
	"$stateParams",
	"$window",
	"userInputRepository",
	"serviceResponseRepository",
	"quoteOptions",
	"paymentService",
	"quoteModelFactory",
	"dynamicRouter",
	"portalServiceWrapper",
	"MAService",
	"labelService",
	"Util",
	"$q",
	"storage",
	"jwtHelper",
	"gtmService",
	"quoteRequestRepository",
	"MODULE_INFO",
	"$compile",
	"$sce",
	"paymentLoggerService",
	"CREDIT_CARD_ATTEMPT",
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$window,
		userInputRepository,
		serviceResponseRepository,
		quoteOptions,
		paymentService,
		quoteModelFactory,
		dynamicRouter,
		portalServiceWrapper,
		MAService,
		labelService,
		util,
		$q,
		storage,
		jwtHelper,
		gtmService,
		quoteRequestRepository,
		MODULE_INFO,
		$compile,
		$sce,
		paymentLoggerService,
		CREDIT_CARD_ATTEMPT
	) {
		var $ctrl = this;
		$ctrl.showPaymentProcessError = false;
		$ctrl.paymentAttempCounter = 0;
		$rootScope.$broadcast("loading-animation-end");

		//check if session function is embedded and append directive
		if ($window.qbe.fieldLabels != undefined) {
			if (angular.isObject($window.qbe.fieldLabels.sessionFunction))
				angular
					.element("div#phglobaloptions_0_divOptionsComponents")
					.after($compile("<div qb-ng-dialog></div>")($scope));
		}

		$scope.$on("session-save-quote", function () {
			$rootScope.$broadcast("session-redirect");
		});

		$ctrl.getLabelFor = function (fieldName) {
			return $sce.trustAsHtml(labelService.getLabelFor(fieldName));
		};

		/**
		 * routing initialisation, enabling/disabling (hiding/showing) available routes
		 * testing for allowed routes and redirecting when not allowed
		 */
		function markCompletedRouteCallback(stateName) {
			storage.setItem("completed-step", stateName);
		}

		function initialiseRouting() {
			switch ($state.$current.parent.name) {
				case "vehicle":
					var stepConditions = {
						"vehicle.policy-start-date": function () {
							return (
								$state.$current.name ==
								"vehicle.policy-start-date"
							);
						},
					};
					break;
				case "home":
					var stepConditions = {
						"home.policy-start-date": function () {
							return (
								$state.$current.name == "home.policy-start-date"
							);
						},
					};
					break;
				case "caravan":
					var stepConditions = {
						"caravan.policy-start-date": function () {
							return (
								$state.$current.name ==
								"caravan.policy-start-date"
							);
						},
					};
					break;
				case "bike":
					var stepConditions = {
						"bike.policy-start-date": function () {
							return (
								$state.$current.name == "bike.policy-start-date"
							);
						},
					};
					break;
				default:
			}

			dynamicRouter.initialise(
				$state.current.name,
				$state.$current.parent.name,
				stepConditions,
				markCompletedRouteCallback
			);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}
		/** End of routing logic */

		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.sections = {};
		$ctrl.moduleId = MODULE_INFO.id;

		$ctrl.cybersourceiFrameUrl = $state.href(
			"cybersourcePaymentForm",
			null,
			{ absolute: true }
		);

		// TODO: better iframe solution
		$ctrl.addCybersourceiFrame = $ctrl.addCybersourceRetryAttempt = $ctrl.addCybersourceLastAttempt = false;

		$ctrl.summaryModel = quoteModelFactory.create();

		function getDefaultValues() {
			return {
				fromFullQuote: true,
				paymentForm: {
					paymentDetails: {
						paymentOptions: "yearly",
					},
				},
			};
		}

		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left,
				});
			}
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn,
			};
		};

		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on("error", function (event, error) {
			$state.go("error", error);
		});

		/**
		 * calls MA Services to add marketing data.
		 */
		$scope.$on("perform-ma-service", function (event, triggeredBy) {
			performMAServices(triggeredBy);
		});

		$scope.$on("back", function () {
			gtmService.trackEvent("back");
			$ctrl.back();
		});

		/**
		 * called from qbFormSection and any other panel that requires a requote based on new values.
		 */
		$scope.$on("requote", function (event, page) {
			gtmService.trackEvent("requote");
			$rootScope.$broadcast("loading-animation-start");
			var formData = getUserInput();
			getRequote(formData, page, function (resp) {
				$rootScope.$broadcast("loading-animation-end");
				$rootScope.$broadcast("quote-received", resp);
				$rootScope.$broadcast("selected-quote-changed");
			});
		});

		function getUserInput() {
			var formData = getFormInput();
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}
			return formData;
		}

		function getRequote(formData, page, callback) {
			portalServiceWrapper.updateQuote(formData);
			var requoteOptions = quoteOptions.getRequoteOptions(
				MODULE_INFO.paymentPageRouteName
			);
			if (requoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						requoteOptions.permutations,
						requoteOptions.rules
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						console.log(err);
						broadcastError(err, "Requote error");
					});
			} else {
				return false;
			}
			return true;
		}

		$ctrl.save = function () {
			$rootScope.$broadcast("open-modal", { modal: "saveQuote" });
		};

		$ctrl.back = function () {
			gtmService.trackEvent("back");
			$scope.$root.$broadcast("hide-top-banner");
			$scope.$broadcast("reset-field-errors");
			var backState = dynamicRouter.back();
			if (backState) $state.go(backState);
			else {
				var formData = getUserInput();
				if (formData.rapidEstimateUrl)
					window.location.href = formData.rapidEstimateUrl;
			}
		};

		$ctrl.submit = function (form) {
			gtmService.trackEvent("click-payment");
			$ctrl.showErrorSummary = false;
			if (form.$invalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}

			processPayment(form);
		};

		function performMAServices(eventName) {
			getUserInput();
			var mainPolicyHolder = userInputRepository.get(
				{},
				"caravanForm.mainPolicyHolder"
			);
			var policyEmail = userInputRepository.get({}, "email");
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom(
				"quote"
			);
			var maData = {
				pageName: $state.current.name,
				mainPolicyHolder: mainPolicyHolder,
				policyEmail: policyEmail,
				annualResult: quoteResult.getAnnual(),
				monthlyResult: quoteResult.getMonthly(),
				quoteId: savedQuote ? savedQuote.quoteID : null,
			};
			MAService.mergeContacts(eventName, maData);
		}

		function processPayment(form) {
			formData = getUserInput();

			var paymentDetailsForm = form.paymentDetails;

			userInputRepository.update(formData);

			$ctrl.paymentAttempCounter++; // iterate payment attempt
			$ctrl.showPaymentProcessError = false;
			$ctrl.paymentMethod =
				formData.paymentForm.paymentDetails.paymentMethod;

			$rootScope.$broadcast("loading-animation-start");
			switch (formData.paymentForm.paymentDetails.paymentMethod) {
				case "creditcard":
					payByCreditCard(formData, paymentDetailsForm);
					break;
				case "paypal":
					// handled by qbFormSection.directive.payByPaypal()
					break;
				case "bankaccount":
					payByDirectDebit(formData);
					break;
			}
		}

		function payByCreditCard(formData, form) {
			paymentService.payByCreditCard(
				// pass credit card data
				{
					cardNumber: formData.paymentForm.paymentDetails.cardNumber,
					cardHolderName:
						formData.paymentForm.paymentDetails.cardHolderName,
					cvc: formData.paymentForm.paymentDetails.cardCvc,
					type: form.cardNumber.$ccType,
					cardExpiryDate: form.cardExpiryDate.$viewValue,
				},
				// on successfully calling the Create Creditcard Payment service
				function (creditCardPaymentData) {
					// make the scope available globally. This data will be used by the iFrame to construct the form that will post to Cybersource
					$window.$controllerScope = $scope;
					// set the data to send to Cybersource to the scope
					$scope.creditCardPaymentData = creditCardPaymentData;
					// set the URL for the iFrame to the Cybersource Payment Form (which will use the `creditCardPaymentData`) to generate and submit the form
					$ctrl.addCybersourceiFrame = true;

					if ($ctrl.paymentAttempCounter == 2) {
						$ctrl.addCybersourceRetryAttempt = true;
					}

					if ($ctrl.paymentAttempCounter == CREDIT_CARD_ATTEMPT) {
						$ctrl.addCybersourceLastAttempt = true;
					}
				},
				// on error
				function (errorResponse) {
					paymentLoggerService.trackQuoteStatus(
						"cc payment error",
						"show oh snap page",
						errorResponse
					);
					//dd-4003-push error to gtm data layer
					gtmService.trackEvent(errorResponse, "paymentError");
					console.error(errorResponse);
					$state.go("error");
				}
			);
		}

		function payByDirectDebit(formData) {
			paymentService.payByDirectDebit(
				// pass bank account data
				{
					bsb: formData.paymentForm.paymentDetails.bsb,
					accountNumber:
						formData.paymentForm.paymentDetails.accountNumber,
					accountName:
						formData.paymentForm.paymentDetails.accountName,
				},
				// on successfully calling the Create Direct Debit Payment service
				function (directDebitPaymentData) {
					$scope.onPaymentCallback(true, directDebitPaymentData);
				},
				// on error
				function (errorResponse) {
					paymentLoggerService.trackQuoteStatus(
						"bank debit payment error",
						"show oh snap page",
						errorResponse
					);
					//dd-4003-push error to gtm data layer
					gtmService.trackEvent(errorResponse, "paymentError");
					console.error(errorResponse);
					//yearly bank account will not redirect to oh snap page
					if (
						formData.paymentForm.paymentDetails.paymentOptions ===
						"yearly"
					) {
						$rootScope.$broadcast("loading-animation-end");
						$ctrl.showPaymentProcessError = true;
					} else {
						$state.go("error");
					}
				}
			);
		}

		/**
		 * Initialisation method of the payment page
		 */
		$ctrl.initPaymentPage = function () {
			initialiseRouting();

			util.dispatchCustomEvent("register-labels");
			$ctrl.termsAndConditions = false;
			var formData = getUserInput();
			formData.paymentForm.paymentDetails.termsAndConditions = false;
			quoteOptions.setSelectedPaymentFrequency(
				formData.paymentForm.paymentDetails.paymentOptions
			);
			$ctrl.formData = formData;
			getRequote(formData);
			$scope.$on("payment-method-changed", function (
				event,
				paymentMethod
			) {
				$ctrl.paymentMethod = paymentMethod;
			});
			$scope.$on("terms-and-conditions-changed", function (
				event,
				termsAndConditions
			) {
				$ctrl.termsAndConditions = termsAndConditions;
			});
		};

		/**
		 * This callback is called from the iFrame when the response is received from the GuideWire payment service
		 * @param success
		 * @param stateParams
		 */
		$scope.onPaymentCallback = function (success, params) {
			$rootScope.$broadcast("loading-animation-end");

			if (success && params.status !== "PROCESS_FAIL") {
				var confirmationData = {
					policyNumber: params.policyNumber,
					accountNumber: params.accountNumber,
					isAwaitingProcess: params.status === "AWAITING_PROCESS",
				};
				paymentLoggerService.trackQuoteStatus(
					"payment successful",
					"show done page",
					null
				);
				// Go to confirmation
				$state.go(MODULE_INFO.donePageRouteName, confirmationData);
			} else {
				// payment error - show error page
				// yearly bank account will not redirect to oh snap page
				if (
					$ctrl.formData.paymentForm.paymentDetails.paymentOptions ===
						"yearly" &&
					$ctrl.paymentMethod === "bankaccount"
				) {
					paymentLoggerService.trackQuoteStatus(
						"payment unsuccessful - bank debit",
						"show oh snap page",
						null
					);
					$ctrl.showPaymentProcessError = true;
					$ctrl.paymentErrorDescription = $ctrl.getLabelFor(
						"bankAccountError"
					);
				}

				// credit card payment retry
				// catch error param from GW
				// send to referral after max attempts
				if ($ctrl.paymentMethod === "creditcard") {
					if (
						angular.isDefined(params.error) &&
						params.error !== ""
					) {
						$ctrl.paymentErrorDescription =
							labelService.getValidationMessagesFor(
								"paymentMethod",
								"ccError"
							) +
							" " +
							params.error;
					} else {
						$ctrl.paymentErrorDescription = labelService.getValidationMessagesFor(
							"paymentMethod",
							"ccErrorDefault"
						);
					}

					if ($ctrl.paymentAttempCounter === CREDIT_CARD_ATTEMPT) {
						paymentLoggerService.trackQuoteStatus(
							"payment unsuccessful - credit card",
							"show referral page",
							null
						);

						var savedQuote = serviceResponseRepository.getLastResponseFrom(
							"quote"
						);
						var referralParams = {
							declineType: savedQuote.quoteID,
							declineCodes: ["ccPaymentError"],
						};
						$state.go("referral", referralParams);
					} else {
						$ctrl.showPaymentProcessError = true;

						paymentLoggerService.trackQuoteStatus(
							"payment unsuccessful - credit card",
							"show payment page",
							null
						);
					}
				}
			}
		};
	},
]);
